import moment from "moment";
import { CloseOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import { capitalizeFirst, formatTimeRange } from "../Common/CommonFunction";
import './Customappointmentmodal.css'
import { useEffect, useState } from "react";
const { Title, Text } = Typography;

export const Customappointmentmodal = (props) => {
    const { appointmentData, appointmentDataActual, closeModal } = props
    const [AdditionalCategorydata, setAdditionalCategorydata] = useState({ getAllHealthScreenDataById: null, allGPproduct: null });
    const appointmentDataNew = props.appointmentDataActual.clinic_id && props?.getAllHealthScreenData?.location?.allClinicDataByID && props?.getAllHealthScreenData?.location?.allClinicDataByID && props.getAllHealthScreenData.location.allClinicDataByID[props.appointmentDataActual.clinic_id] ? props.getAllHealthScreenData.location.allClinicDataByID[props.appointmentDataActual.clinic_id] : props.appointmentDataActual.clinic_id

    useEffect(() => {
        if (props && props.getAllHealthScreenData) {
            let getAllHealthScreenDataById = {}, allGPproduct = {}
            if (props.getAllHealthScreenData && props.getAllHealthScreenData.getAllHealthScreenData && props.getAllHealthScreenData.getAllHealthScreenData.data && props.getAllHealthScreenData.getAllHealthScreenData.data.length) {
                props.getAllHealthScreenData.getAllHealthScreenData.data.map(data => {
                    getAllHealthScreenDataById[data.non_gp_product_id] = data
                })
            }
            if (props.getAllHealthScreenData && props.getAllHealthScreenData.allGPproduct && props.getAllHealthScreenData.allGPproduct && props.getAllHealthScreenData.allGPproduct.length) {
                props.getAllHealthScreenData.allGPproduct.map(data => {
                    allGPproduct[data.gp_product_id] = data
                })
            }
            setAdditionalCategorydata({ getAllHealthScreenDataById, allGPproduct })
        }
    }, [props.getAllHealthScreenData])
    const _storedCategories = (() => {
      try { 
        const parsed = JSON.parse(localStorage.getItem('showCategory') || '{}');
        return Array.isArray(parsed) ? parsed : Object.values(parsed);
      } catch(e) { return []; }
    })();
    const _apptCat = _storedCategories.find(c =>
        c.product_category_id == appointmentDataActual?.product_category_id
    );
    const _uiCatType = _apptCat?.type || (
        appointmentDataActual?.product_category_id == 1 ? 'gp' :
        appointmentDataActual?.product_category_id == 3 ? 'corporate' : 'd2c'
    );

    return (
        <div
            className="custom-appointment-modal-new"
            style={{
                position: 'absolute',
                width: 380,
                padding: 16,
                backgroundColor: '#F0FAFA',
                borderRadius: 12,
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                right: 50,
                height: 380
            }}
        >
            <div
                style={{
                    backgroundColor: '#008385',
                    padding: '10px 16px',
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px',
                    color: 'white',
                    margin: '-16px -16px 12px -16px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                }}
            >
                Appointment details:
            </div>
            <div style={{ position: 'absolute', right: 20, top: 15 }} onClick={closeModal} >
                <CloseOutlined style={{ color: "red", fontSize: "18px" }} />
            </div>
            <p style={{ marginLeft: 36, marginRight: 36, marginTop: 0, marginBottom: 10 }}>{appointmentDataNew?.name || 'Canary Wharf'}</p>
            <p style={{ marginLeft: 36, marginRight: 36, marginTop: 0, marginBottom: 10 }}>
                {appointmentDataActual?.start_time
                    ? moment(appointmentDataActual.start_time, "YYYY-MM-DD HH:mm:ss.SSS").format("dddd, Do MMMM, YYYY")
                    : 'Monday, 8th January, 2025'}
            </p>
            <p style={{ marginLeft: 36, marginRight: 36, marginTop: 0, marginBottom: 10 }}>
                {appointmentDataActual?.start_time && appointmentDataActual?.end_time
                    ? formatTimeRange(appointmentDataActual.start_time, appointmentDataActual.end_time).start + '-' + formatTimeRange(appointmentDataActual.start_time, appointmentDataActual.end_time).end
                    : '8:30 - 9:00'}
            </p>
            <p style={{ marginLeft: 36, marginRight: 36, marginTop: 0, marginBottom: 10 }}>{_uiCatType === 'gp' ? 'GP appointments' : 'Health screens'} - {appointmentDataActual.charges ? ' £' + appointmentDataActual.charges : ' £0'}</p>
            <p style={{ marginLeft: 36, marginRight: 36, marginTop: 0, marginBottom: 10 }}>{appointmentDataActual?.product_id && AdditionalCategorydata.getAllHealthScreenDataById && AdditionalCategorydata.getAllHealthScreenDataById[appointmentDataActual?.product_id] ? AdditionalCategorydata.getAllHealthScreenDataById[appointmentDataActual?.product_id].name ?? '' : appointmentDataActual.patient && appointmentDataActual.patient?.appointment_reason && AdditionalCategorydata.allGPproduct && AdditionalCategorydata.allGPproduct[appointmentDataActual.patient?.appointment_reason] ? AdditionalCategorydata.allGPproduct[appointmentDataActual.patient?.appointment_reason].name ?? '' : ''} </p>
            {/* <p style={{ marginLeft: 36, marginRight: 36, marginTop: 0, marginBottom: 10 }}>{_uiCatType === 'gp' ? 'GP appointments' : 'Health screens'}</p> */}
            <p style={{ marginLeft: 36, marginRight: 36, marginTop: 0, marginBottom: 10 }}>
                {appointmentDataActual.preferred_gender && appointmentDataActual.preferred_gender ? capitalizeFirst(appointmentDataActual.preferred_gender) : 'Male'}, {appointmentDataActual.patient && appointmentDataActual.language_name ? appointmentDataActual.language_name : 'English'}
            </p >
            <p style={{ marginLeft: 36, marginRight: 36, marginTop: 0, marginBottom: 10 }}>{appointmentDataActual && appointmentDataActual.patient && appointmentDataActual.patient.first_name ? appointmentDataActual.patient.first_name + appointmentDataActual.patient?.last_name ?? '' : 'John Doe'}</p>
            <p style={{ marginLeft: 36, marginRight: 36, marginTop: 0, marginBottom: 10 }}>{appointmentDataActual.patient?.email ? appointmentDataActual.patient?.email : 'john.doe@gmail.com'} &nbsp;{appointmentDataActual.patient?.mobile_number ? appointmentDataActual.patient?.mobile_number : '09876-543-210'}</p>
            {/* <p style={{ marginLeft: 36, marginRight: 36, marginTop: 0, marginBottom: 10 }}> </p> */}
            <p style={{ marginLeft: 36, marginRight: 36, marginTop: 0, marginBottom: 10 }}>
                Notes:  {appointmentDataActual?.notes ?? ''}
            </p>
            {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
                <p style={{ marginLeft: 36, marginRight: 36, marginTop: 0, marginBottom: 10 }}>Additional Notes:</p>
                <EditOutlined />
            </div> */}
        </div>
    );
};